/**
 * The task table groups tasks under their phase, and the tasks belonging to no
 * phase are grouped under a synthetic row whose id is this sentinel. It is a
 * display id: it identifies a group in the tree, and no phase in the database.
 */
export const NO_PHASE_ID = 'no-phase';

/**
 * The phase id to send to the backend for a group id taken from the tree, or
 * null for the No Phase group.
 *
 * Needed because the sentinel is a non-empty string, so the usual `?? null` and
 * `|| null` both pass it straight through to a mutation, which then resolves it
 * to a phase that is not on the project and refuses the write. Anything falsy
 * is also reported as null, so a caller cannot leak `undefined` into an input
 * that means "no phase" by omission.
 */
export const phaseIdForBackend = (groupPhaseId: string | null | undefined): string | null =>
	!groupPhaseId || groupPhaseId === NO_PHASE_ID ? null : groupPhaseId;
